import type { User } from '../../auth/types';

export interface ModuleMeta {
  id: 'scouting' | 'spraying' | 'consumables' | 'fertilizing' | 'picking' | 'auditing' | 'settings' | 'system';
  /** First URL segment that identifies this module, e.g. 'spray'. */
  pathPrefix: string;
  /** Top-level navigate target. */
  to: string;
  /** i18n key for the displayed module name. */
  labelKey: string;
  /** Single emoji used as the module glyph (matches existing Home dashboard usage). */
  emoji: string;
  /** bootstrap-icons class for places where an SVG icon is preferred. */
  icon: string;
  /** Module key used for access checks (e.g. 'scouting'). */
  moduleKey: string;
  /** True for modules that render a "Coming soon" badge. */
  disabled?: boolean;
}

export const MODULE_META: ModuleMeta[] = [
  { id: 'scouting',    pathPrefix: 'scouting', to: '/scouting', labelKey: 'home.modules.scouting',    emoji: '🔍', icon: 'bi-search',           moduleKey: 'scouting' },
  { id: 'spraying',    pathPrefix: 'protection', to: '/protection', labelKey: 'home.modules.spraying',    emoji: '💧', icon: 'bi-droplet-fill',     moduleKey: 'spraying' },
  { id: 'consumables', pathPrefix: 'consumables', to: '/consumables', labelKey: 'home.modules.consumables', emoji: '📦', icon: 'bi-box-seam',     moduleKey: 'consumables' },
  { id: 'fertilizing', pathPrefix: 'nutrition', to: '/nutrition', labelKey: 'home.modules.fertilizing', emoji: '🌱', icon: 'bi-flower1',          moduleKey: 'fertilizing', disabled: false },
  { id: 'picking',     pathPrefix: 'harvest',  to: '/harvest',  labelKey: 'home.modules.picking',     emoji: '🍊', icon: 'bi-basket',           moduleKey: 'picking', disabled: true },
  { id: 'auditing',    pathPrefix: 'audit',    to: '/audit',    labelKey: 'home.modules.audit',       emoji: '📋', icon: 'bi-clipboard-check',  moduleKey: 'auditing' },
  { id: 'settings',    pathPrefix: 'settings', to: '/settings', labelKey: 'home.modules.settings',    emoji: '⚙️', icon: 'bi-gear',             moduleKey: 'settings' },
  { id: 'system',      pathPrefix: 'system',   to: '/system',   labelKey: 'home.modules.system',      emoji: '🛠️', icon: 'bi-shield-lock',      moduleKey: 'system' },
];

export function moduleMetaForPath(pathname: string): ModuleMeta | null {
  const first = pathname.replace(/^\/+/, '').split('/')[0];
  return MODULE_META.find(m => m.pathPrefix === first) ?? null;
}

/**
 * Filter MODULE_META based on the user's tenant.
 * - System tenant users see ONLY the System Admin module.
 * - Tenant users see all seven tenant modules and never the System module.
 */
export function visibleModules(user: Pick<User, 'tenantId'> | null | undefined): ModuleMeta[] {
  if (!user) return [];
  if (user.tenantId === 'system') {
    return MODULE_META.filter(m => m.id === 'system');
  }
  return MODULE_META.filter(m => m.id !== 'system');
}
